/**
 * @generated SignedSource<<7db080af1065be0c595326ace951d016>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type route_TopnavQuery$variables = {
  slug: string;
};
export type route_TopnavQuery$data = {
  readonly club: {
    readonly leaderboard: string | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"bottomTabs_club" | "topnavFragment">;
  };
  readonly user: {
    readonly " $fragmentSpreads": FragmentRefs<"topnavRightPanel_user">;
  } | null | undefined;
};
export type route_TopnavQuery = {
  response: route_TopnavQuery$data;
  variables: route_TopnavQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "slug"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "slug",
    "variableName": "slug"
  }
],
v2 = [
  {
    "kind": "Literal",
    "name": "key",
    "value": "LEADERBOARD"
  }
],
v3 = {
  "alias": "leaderboard",
  "args": (v2/*: any*/),
  "kind": "ScalarField",
  "name": "configuration",
  "storageKey": "configuration(key:\"LEADERBOARD\")"
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "enabled",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v9 = [
  (v5/*: any*/)
],
v10 = [
  {
    "kind": "Literal",
    "name": "status",
    "value": "ACTIVE"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "route_TopnavQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topnavFragment"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "bottomTabs_club"
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "topnavRightPanel_user"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "route_TopnavQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Club",
        "kind": "LinkedField",
        "name": "club",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "AiPersona",
            "kind": "LinkedField",
            "name": "aiPersona",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "showPoweredLogo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "SpaceGroup",
            "kind": "LinkedField",
            "name": "groups",
            "plural": true,
            "selections": [
              (v5/*: any*/),
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "spaces",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v5/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "icon",
                    "storageKey": null
                  },
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "isMember",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "position",
                    "storageKey": null
                  },
                  {
                    "kind": "TypeDiscriminator",
                    "abstractKey": "__isSpace"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "postPolicy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "commentPolicy",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hiddenUniversal",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIntegrationProduct",
                    "kind": "LinkedField",
                    "name": "primaryProduct",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AccessGroupSpace",
                    "kind": "LinkedField",
                    "name": "accessGroups",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AccessGroup",
                        "kind": "LinkedField",
                        "name": "accessGroup",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ExternalProductAccessGroup",
                            "kind": "LinkedField",
                            "name": "externalProducts",
                            "plural": true,
                            "selections": (v9/*: any*/),
                            "storageKey": null
                          },
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v5/*: any*/),
          (v7/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ClubSubscription",
            "kind": "LinkedField",
            "name": "subscription",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ClubSubscriptionFeature",
                "kind": "LinkedField",
                "name": "features",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "key",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "first",
                "value": 10000
              }
            ],
            "concreteType": "OfferConnection",
            "kind": "LinkedField",
            "name": "offers",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "OfferEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PaymentIntegrationProduct",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "productName",
                        "storageKey": null
                      },
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ExternalProductAccessGroup",
                        "kind": "LinkedField",
                        "name": "accessGroup",
                        "plural": false,
                        "selections": (v9/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "offers(first:10000)"
          },
          {
            "alias": "coursePageTitle",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "COURSE_PAGE_TITLE"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"COURSE_PAGE_TITLE\")"
          },
          {
            "alias": "communityPageTitle",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "COMMUNITY_PAGE_TITLE"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"COMMUNITY_PAGE_TITLE\")"
          },
          {
            "alias": "eventsPageTitle",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "EVENTS_PAGE_TITLE"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"EVENTS_PAGE_TITLE\")"
          },
          {
            "alias": "leaderboardPageTitle",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "LEADERBOARD_PAGE_TITLE"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"LEADERBOARD_PAGE_TITLE\")"
          },
          {
            "alias": "communityEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "COMMUNITY_ENABLED"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"COMMUNITY_ENABLED\")"
          },
          {
            "alias": "coursesEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "COURSES_ENABLED"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"COURSES_ENABLED\")"
          },
          {
            "alias": "eventsEnabled",
            "args": [
              {
                "kind": "Literal",
                "name": "key",
                "value": "EVENTS_ENABLED"
              }
            ],
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"EVENTS_ENABLED\")"
          },
          {
            "alias": "rankingEnabled",
            "args": (v2/*: any*/),
            "kind": "ScalarField",
            "name": "configuration",
            "storageKey": "configuration(key:\"LEADERBOARD\")"
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "orderBy",
                "value": "CHRONOLOGICAL"
              }
            ],
            "concreteType": "EventConnection",
            "kind": "LinkedField",
            "name": "events",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "EventEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Event",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": (v9/*: any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "events(orderBy:\"CHRONOLOGICAL\")"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "CoursePage",
            "kind": "LinkedField",
            "name": "coursePage",
            "plural": false,
            "selections": [
              (v5/*: any*/),
              {
                "alias": null,
                "args": (v10/*: any*/),
                "concreteType": "CourseCategory",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": (v10/*: any*/),
                    "concreteType": "Course",
                    "kind": "LinkedField",
                    "name": "courses",
                    "plural": true,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "canView",
                        "storageKey": null
                      },
                      (v5/*: any*/)
                    ],
                    "storageKey": "courses(status:\"ACTIVE\")"
                  },
                  (v5/*: any*/)
                ],
                "storageKey": "categories(status:\"ACTIVE\")"
              }
            ],
            "storageKey": null
          },
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ImageFile",
            "kind": "LinkedField",
            "name": "photo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "signedUrl",
                "storageKey": null
              },
              (v5/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "avatarFallback",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "bio",
            "storageKey": null
          },
          (v5/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "441cc6072b61c6c35a31dee96c650cc7",
    "id": null,
    "metadata": {},
    "name": "route_TopnavQuery",
    "operationKind": "query",
    "text": "query route_TopnavQuery(\n  $slug: String!\n) {\n  club(slug: $slug) {\n    ...topnavFragment\n    ...bottomTabs_club\n    leaderboard: configuration(key: \"LEADERBOARD\")\n    id\n  }\n  user {\n    ...topnavRightPanel_user\n    id\n  }\n}\n\nfragment bottomTabs_club on Club {\n  id\n  communityEnabled: configuration(key: \"COMMUNITY_ENABLED\")\n  coursesEnabled: configuration(key: \"COURSES_ENABLED\")\n  eventsEnabled: configuration(key: \"EVENTS_ENABLED\")\n  rankingEnabled: configuration(key: \"LEADERBOARD\")\n  events(orderBy: CHRONOLOGICAL) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  groups {\n    spaces {\n      __typename\n      isMember\n      visibility\n      id\n    }\n    id\n  }\n  coursePage {\n    id\n    categories(status: ACTIVE) {\n      courses(status: ACTIVE) {\n        visibility\n        canView\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment communitySidebarFragment on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n      slug\n      visibility\n      isMember\n      position\n      ...spaceCreateDialog_spaceFragment\n      ...spaceDeleteDialogFragment\n    }\n    ...groupCreateDialog_updateFragment\n    ...groupDeleteDialogFragment\n  }\n  ...spaceCreateDialog_clubFragment\n  ...feedReorderDialog_feed\n}\n\nfragment feedReorderDialog_feed on Club {\n  ...feedReorderDialog_groups\n  ...feedReorderDialog_spaces\n}\n\nfragment feedReorderDialog_groups on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n    }\n  }\n}\n\nfragment feedReorderDialog_spaces on Club {\n  groups {\n    id\n    name\n    spaces {\n      __typename\n      id\n      icon\n      name\n      position\n    }\n  }\n}\n\nfragment groupCreateDialog_updateFragment on SpaceGroup {\n  id\n  name\n}\n\nfragment groupDeleteDialogFragment on SpaceGroup {\n  id\n  name\n  spaces {\n    __typename\n    id\n  }\n}\n\nfragment profileUpdateDialog_user on User {\n  firstName\n  lastName\n  username\n  avatarFallback\n  photo {\n    id\n    signedUrl\n  }\n  email\n  bio\n}\n\nfragment spaceCreateDialog_clubFragment on Club {\n  id\n  slug\n  groups {\n    spaces {\n      __typename\n      id\n      name\n    }\n    id\n  }\n  subscription {\n    features {\n      key\n      value\n    }\n    id\n  }\n  offers(first: 10000) {\n    edges {\n      node {\n        id\n        productName\n        enabled\n        accessGroup {\n          id\n        }\n      }\n    }\n  }\n  ...upgradePlanCard_clubFragment\n}\n\nfragment spaceCreateDialog_spaceFragment on Space {\n  __isSpace: __typename\n  id\n  name\n  icon\n  visibility\n  postPolicy\n  commentPolicy\n  hiddenUniversal\n  primaryProduct {\n    id\n  }\n  accessGroups {\n    accessGroup {\n      externalProducts {\n        id\n      }\n      id\n    }\n    id\n  }\n}\n\nfragment spaceDeleteDialogFragment on Space {\n  __isSpace: __typename\n  id\n  name\n}\n\nfragment topnavFragment on Club {\n  aiPersona {\n    enabled\n    id\n  }\n  showPoweredLogo\n  ...communitySidebarFragment\n  coursePageTitle: configuration(key: \"COURSE_PAGE_TITLE\")\n  communityPageTitle: configuration(key: \"COMMUNITY_PAGE_TITLE\")\n  eventsPageTitle: configuration(key: \"EVENTS_PAGE_TITLE\")\n  leaderboardPageTitle: configuration(key: \"LEADERBOARD_PAGE_TITLE\")\n  communityEnabled: configuration(key: \"COMMUNITY_ENABLED\")\n  coursesEnabled: configuration(key: \"COURSES_ENABLED\")\n  eventsEnabled: configuration(key: \"EVENTS_ENABLED\")\n  rankingEnabled: configuration(key: \"LEADERBOARD\")\n  events(orderBy: CHRONOLOGICAL) {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n  groups {\n    spaces {\n      __typename\n      isMember\n      visibility\n      id\n    }\n    id\n  }\n  coursePage {\n    id\n    categories(status: ACTIVE) {\n      courses(status: ACTIVE) {\n        visibility\n        canView\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment topnavRightPanel_user on User {\n  photo {\n    signedUrl\n    id\n  }\n  avatarFallback\n  ...profileUpdateDialog_user\n}\n\nfragment upgradePlanCard_clubFragment on Club {\n  subscription {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab51aa396a2f80ee5feb3d94e1d5d92f";

export default node;
